// Color palette extracted from Intuition AI logo and dark theme
export const colors = {
  primary: {
    main: '#6366f1', // Indigo
    light: '#818cf8',
    dark: '#4338ca',
    contrast: '#ffffff'
  },
  secondary: {
    main: '#8b5cf6', // Purple
    light: '#a78bfa',
    dark: '#7c3aed',
    contrast: '#ffffff'
  },
  accent: {
    main: '#06b6d4', // Cyan
    light: '#67e8f9',
    dark: '#0891b2',
    contrast: '#ffffff'
  },
  background: {
    primary: '#0f172a', // Dark slate
    secondary: '#1e293b',
    tertiary: '#334155',
    paper: '#1e293b'
  },
  text: {
    primary: '#f8fafc',
    secondary: '#cbd5e1',
    disabled: '#64748b',
    hint: '#94a3b8'
  },
  success: '#10b981',
  warning: '#f59e0b',
  error: '#ef4444',
  info: '#3b82f6'
};

export const gradients = {
  primary: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
  secondary: 'linear-gradient(135deg, #8b5cf6 0%, #06b6d4 100%)',
  background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)'
};

export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '48px'
};

export const breakpoints = {
  mobile: '480px',
  tablet: '768px',
  desktop: '1024px',
  widescreen: '1200px'
};
